import VueRouter from 'vue-router'
import LoginView from '../views/Login'
import Calendar from '../views/Calendar'
import NotFound from '../views/NotFound'


const routes = [
  {
    path: '/login',
    name: 'Login',
    component: LoginView,
  },
  {
    path: '/',
    name: 'Main',
    component: Calendar
  },
  {
    path: '/:catchAll(.*)',
    name: 'NotFound',
    component: NotFound
  }
]

const router = new VueRouter({
  mode: 'history',
  routes: routes
})

export default router
